import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { Box } from "@mui/material";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { memo, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { IIntegrationRuleNotifications } from "../../../../../../models/integration-rule-notification";
import MainApi from "../../../../../../services/mainApi.service";
import { IntegrationRuleNotification } from "./IntegrationRuleNotificationForm/IntegrationRuleNotification";

const INTEGRATION_RULE_NOTIFICATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleNotification/";
const integrationRuleNotificationService =
  new MainApi<IIntegrationRuleNotifications>(
    INTEGRATION_RULE_NOTIFICATION_ROUTE,
  );

export const IntegrationRuleNotificationsPage = memo(() => {
  const { id: busIntegrationRuleId } = useParams();

  const [notificationForm, setNotificationForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const columns: GridColDef<IIntegrationRuleNotifications>[] = [
    {
      field: "profile",
      headerName: "Perfil",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "channelNotification",
      headerName: "Canal",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "typelNotification",
      headerName: "Tipo de notificação",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "content",
      headerName: "Conteúdo",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    setNotificationForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<IIntegrationRuleNotifications>,
  ) => {
    if (!params.row) return;
    setNotificationForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = () => {
    setSelectedId(undefined);
    setNotificationForm(false);
  };

  const params = useMemo(() => {
    return {
      _4uBusIntegrationRuleId: busIntegrationRuleId,
    };
  }, [busIntegrationRuleId]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {notificationForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <IntegrationRuleNotification
            id={selectedId}
            busIntegrationRuleId={busIntegrationRuleId}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!notificationForm && (
        <Box height={600}>
          <Table<IIntegrationRuleNotifications>
            showDefaultMacroFilters={false}
            service={integrationRuleNotificationService}
            serviceProps={params}
            columns={columns}
            title="Notificações"
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputPlaceHolder="Pesquise por uma notificação"
            addButtonLabel="Adicionar notificação"
            confirmOptions={{
              title: "Deletar notificação?",
              description: "Isso vai permanentemente deletar a notificação",
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
